

import { userApi } from "../../config";

export async function fetchUserDetails() {
    try {
        const res = await userApi.get("/get-user-profile", {headers: {"Authorization": `Bearer ${sessionStorage.getItem("userAccessToken")}`}});
        return res.data;
    }catch (err: any) {
        return err.response.data;
    }
}

export async function updateDetails(data: any) {
    try {
        const res = await userApi.put("/update-user-profile", data, {
            headers: {
                "Authorization": `Bearer ${sessionStorage.getItem("userAccessToken")}`,
            },
        });

        if (res.status === 200) {
            return res.data; // Success
        } else {
            throw new Error("Failed to update profile"); // For non-200 status
        }
    } catch (err: any) {
        const errorMessage = err?.response?.data?.message || 
                            (typeof err?.response?.data === "string" ? err.response.data : "Failed to update profile");
        return {message: errorMessage};
    }
}


export async function updatePassword(data: any) {
    try {
        const res = await userApi.put("/update-user-password", data, {headers: {"Authorization": `Bearer ${sessionStorage.getItem("userAccessToken")}`}});
        return res.data;
    }catch (err: any) {
        return {message: err?.response?.data.message || "unexpected!"};
    }
}

export async function UnEnrollClass(bookingId: string) {
    try {
        const res = await userApi.delete(`/unenroll-class/${bookingId}`, {headers: {"Authorization": `Bearer ${sessionStorage.getItem("userAccessToken")}`}})
        return res.data;
    }catch (err: any) {
        return {message: err?.response?.data.message || "unexpected!"};
    }
}